import store from '../../store';
import Errors from '../../Errors';
import CartHelpersMixin from '../../mixins/CartHelpersMixin';
import ProductHelpersMixin from '../../mixins/ProductHelpersMixin';
import Inputmask from 'inputmask';

export default {
    mounted() {
        var phone = new Inputmask('+7(999) 999-9999');
        if (document.getElementById('phone')) {
            phone.mask(document.getElementById('phone'));
        }
    },
    mixins: [
        CartHelpersMixin,
        ProductHelpersMixin,
    ],

    props: ['customerEmail', 'customerPhone', 'gateways', 'defaultAddress', 'addresses', 'countries'],

    data() {
        return {
            form: {
                customer_email: this.customerEmail,
                customer_phone: this.customerPhone,
                billing: {},
                shipping: {},
                billingAddressId: null,
                shippingAddressId: null,
                newBillingAddress: false,
                newShippingAddress: false,
                shippingAddressKladr: null,
                billingAddressKladr: null,
            },
            states: {
                billing: {},
                shipping: {},
            },
            district: {
                billing: {},
                shipping: {},
            },
            placingOrder: false,
            errors: new Errors(),
            stripe: null,
            stripeCardElement: null,
            stripeError: null,
        };
    },

    computed: {
        hasAddress() {
            return Object.keys(this.addresses).length !== 0;
        },

        firstCountry() {
            return Object.keys(this.countries)[0];
        },

        hasBillingStates() {
            return Object.keys(this.states.billing).length !== 0;
        },

        hasShippingStates() {
            return Object.keys(this.states.shipping).length !== 0;
        },

        hasBillingDistrict() {
            return Object.keys(this.district.billing).length !== 0;
        },

        hasShippingDistrict() {
            return Object.keys(this.district.shipping).length !== 0;
        },

        hasNoPaymentMethod() {
            return Object.keys(this.gateways).length === 0;
        },

        firstPaymentMethod() {
            return Object.keys(this.gateways)[0];
        },
        hasShippingAddressKladr() {
            return this.shippingAddressKladr;
        },

        hasBillingAddressKladr() {
            return this.billingAddressKladr;
        },
        shouldShowPaymentInstructions() {
            return ['bank_transfer', 'check_payment'].includes(this.form.payment_method);
        },

        paymentInstructions() {
            if (this.shouldShowPaymentInstructions) {
                return this.gateways[this.form.payment_method].instructions;
            }
        },
    },

    watch: {
        'form.billingAddressId': function () {
            this.mergeSavedAddresses();
        },

        'form.shippingAddressId': function () {
            this.mergeSavedAddresses();
        },

        'form.billing.city': function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        'form.shipping.city': function (newCity) {
            if (newCity) {
                this.addTaxes();
            }
        },

        'form.billing.zip': function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },

        'form.shipping.zip': function (newZip) {
            if (newZip) {
                this.addTaxes();
            }
        },
        'form.billing.kladr': function (newKladr) {
            if (newKladr) {
                this.addTaxes();
            }
        },

        'form.shipping.kladr': function (newKladr) {
            if (newKladr) {
                this.addTaxes();
            }
        },

        'form.billing.state': function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        'form.shipping.state': function (newState) {
            if (newState) {
                this.addTaxes();
            }
        },

        'form.billing.district': function (newDistrict) {
            if (newDistrict) {
                this.addTaxes();
            }
        },

        'form.shipping.district': function (newDistrict) {
            if (newDistrict) {
                this.addTaxes();
            }
        },
        'form.billing.address_1': function (newAddress_1) {
            if (newAddress_1) {
                this.addTaxes();
            }
        },
        'form.shipping.address_1': function (newAddress_1) {
            if (newAddress_1) {
                this.addTaxes();
            }
        },
        'form.ship_to_a_different_address': function () {
            this.addTaxes();
        },

        'form.terms_and_conditions': function () {
            this.errors.clear('terms_and_conditions');
        },

        'form.payment_method': function (newPaymentMethod) {
            if (newPaymentMethod === 'paypal') {
                this.$nextTick(this.renderPayPalButton);
            }

            if (newPaymentMethod !== 'stripe') {
                this.stripeError = '';
            }
        },
    },

    created() {
        if (this.defaultAddress.address_id) {
            this.form.billingAddressId = this.defaultAddress.address_id;
            this.form.shippingAddressId = this.defaultAddress.address_id;
        }

        if (! this.hasAddress) {
            this.form.newBillingAddress = true;
            this.form.newShippingAddress = true;

            this.changeBillingCountry(this.firstCountry);
            this.changeShippingCountry(this.firstCountry);
        }

        this.$nextTick(() => {
            if (this.firstPaymentMethod) {
                this.changePaymentMethod(this.firstPaymentMethod);
            }

            if (this.firstShippingMethod) {
                this.updateShippingMethod(this.firstShippingMethod);
            }

            if (window.Stripe) {
                this.stripe = window.Stripe(EcomShop.stripePublishableKey);

                this.renderStripeElements();
            }
        });
    },

    methods: {
        addNewBillingAddress() {
            this.errors.reset();

            this.form.billing = {};
            this.form.newBillingAddress = ! this.form.newBillingAddress;
        },

        addNewShippingAddress() {
            this.errors.reset();

            this.form.shipping = {};
            this.form.newShippingAddress = ! this.form.newShippingAddress;
        },

        changeBillingAddressKlader(kladr) {
            this.shippingAddressKladr = kladr;
            this.$set(this.form.billing, 'kladr', kladr);

        },


        changeShippingAddressKlader(kladr) {
            this.billingAddressKladr = kladr;
            this.$set(this.form.shipping, 'kladr', kladr);
        },

        mergeSavedAddresses() {
            if (! this.form.newBillingAddress && this.form.billingAddressId) {
                this.form.billing = this.addresses[this.form.billingAddressId];
            }

            if (
                this.form.ship_to_a_different_address
                && ! this.form.newShippingAddress
                && this.form.shippingAddressId
            ) {
                this.form.shipping = this.addresses[this.form.shippingAddressId];
            }
        },

        changeBillingCity(city) {
            this.$set(this.form.billing, 'city', city);
            this.$set(this.form.billing, 'country', 'RU'); //patch no country
        },

        changeShippingCity(city) {
            this.$set(this.form.shipping, 'city', city);
            this.$set(this.form.billing, 'country', 'RU'); //patch no country
        },

        changeBillingZip(zip) {
            this.$set(this.form.billing, 'zip', zip);
            this.$set(this.form.billing, 'country', 'RU'); //patch no country
        },

        changeShippingZip(zip) {
            this.$set(this.form.shipping, 'zip', zip);
            this.$set(this.form.billing, 'country', 'RU'); //patch no country
        },

        changeBillingAddress(address) {
            this.$set(this.form.billing, 'address_1', address);
            this.$set(this.form.billing, 'country', 'RU'); //patch no country
        },

        changeShippingAddress(address) {
            this.$set(this.form.shipping, 'address_1', address);
            this.$set(this.form.shipping, 'country', 'RU'); //patch no country
        },

        changeBillingAddress2(address) {
            this.$set(this.form.billing, 'address_2', address);
            this.$set(this.form.billing, 'country', 'RU'); //patch no country
        },

        changeShippingAddress2(address) {
            this.$set(this.form.shipping, 'address_2', address);
            this.$set(this.form.shipping, 'country', 'RU'); //patch no country
        },

        changeBillingCountry(country) {
            this.$set(this.form.billing, 'country', country);

            this.fetchStates(country, (states) => {
                this.$set(this.states, 'billing', states);
                this.$set(this.form.billing, 'state', '');
            });
        },

        changeShippingCountry(country) {
            this.$set(this.form.shipping, 'country', country);

            this.fetchStates(country, (states) => {
                this.$set(this.states, 'shipping', states);
                this.$set(this.form.shipping, 'state', '');
            });
        },

        fetchStates(country, callback) {
            $.ajax({
                method: 'GET',
                url: route('countries.states.index', { code: country }),
            }).then(callback);
        },

        changeBillingState(state) {
            this.$set(this.form.billing, 'state', state);
        },

        changeShippingState(state) {
            this.$set(this.form.shipping, 'state', state);
        },

        changeBillingDistrict(district) {
            this.$set(this.form.billing, 'district', district);
        },

        changeShippingDistrict(district) {
            this.$set(this.form.shipping, 'district', district);
        },

        changePaymentMethod(paymentMethod) {
            this.$set(this.form, 'payment_method', paymentMethod);
        },

        changeShippingMethod(shippingMethod) {
            this.$set(this.form, 'shipping_method', shippingMethod.name);
        },

        addTaxes() {
            this.loadingOrderSummary = true;

            $.ajax({
                method: 'POST',
                url: route('cart.taxes.store'),
                data: this.form,
            }).then((cart) => {
                store.updateCart(cart);
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.loadingOrderSummary = false;
            });
        },

        placeOrder() {
            if (! this.form.terms_and_conditions || this.placingOrder) {
                return;
            }

            this.placingOrder = true;

            $.ajax({
                method: 'POST',
                url: route('checkout.create'),
                data: this.form,
            }).then((response) => {
                if (response.redirectUrl) {
                    window.location.href = response.redirectUrl;
                } else if (this.form.payment_method === 'stripe') {
                    this.confirmStripePayment(response);
                } else if (this.form.payment_method === 'paytm') {
                    this.confirmPaytmPayment(response);
                } else if (this.form.payment_method === 'razorpay') {
                    this.confirmRazorpayPayment(response);
                } else {
                    this.confirmOrder(response.orderId, this.form.payment_method);
                }
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                }

                this.$notify(xhr.responseJSON.message);

                this.placingOrder = false;
            });
        },

        confirmOrder(orderId, paymentMethod, params = {}) {
            $.ajax({
                method: 'GET',
                url: route('checkout.complete.store', { orderId, paymentMethod, ...params }),
            }).then(() => {
                window.location.href = route('checkout.complete.show');
            }).catch((xhr) => {
                this.placingOrder = false;
                this.loadingOrderSummary = false;

                this.deleteOrder(orderId);
                this.$notify(xhr.responseJSON.message);
            });
        },

        deleteOrder(orderId) {
            if (! orderId) {
                return;
            }

            $.ajax({
                method: 'GET',
                url: route('checkout.payment_canceled.store', { orderId }),
            });
        },

        renderPayPalButton() {
            let vm = this;
            let response;

            window.paypal.Buttons({
                async createOrder() {
                    try {
                        response = await $.ajax({
                            method: 'POST',
                            url: route('checkout.create'),
                            data: vm.form,
                        });

                        return response.resourceId;
                    } catch (xhr) {
                        if (xhr.status === 422) {
                            vm.errors.record(xhr.responseJSON.errors);
                        } else {
                            vm.$notify(xhr.responseJSON.message);
                        }
                    }
                },
                onApprove() {
                    vm.loadingOrderSummary = true;

                    vm.confirmOrder(response.orderId, 'paypal', response);
                },
                onError() {
                    vm.deleteOrder(response.orderId);
                },
                onCancel() {
                    vm.deleteOrder(response.orderId);
                },
            }).render('#paypal-button-container');
        },

        renderStripeElements() {
            this.stripeCardElement = this.stripe.elements().create('card', {
                hidePostalCode: true,
            });

            this.stripeCardElement.mount('#stripe-card-element');
        },

        async confirmStripePayment({ orderId, clientSecret }) {
            let result = await this.stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: this.stripeCardElement,
                    billing_details: {
                        email: this.form.customer_email,
                        name: `${this.form.billing.first_name} ${this.form.billing.last_name}`,
                        address: {
                            city: this.form.billing.city,
                            country: this.form.billing.country,
                            line1: this.form.billing.address_1,
                            line2: this.form.billing.address_2,
                            postal_code: this.form.billing.zip,
                            state: this.form.billing.state,
                        },
                    },
                },
            });

            if (result.error) {
                this.placingOrder = false;
                this.stripeError = result.error.message;

                this.deleteOrder(orderId);
            } else {
                this.confirmOrder(orderId, 'stripe', result);
            }
        },

        confirmPaytmPayment({ orderId, amount, txnToken }) {
            let config = {
                root: '',
                flow: 'DEFAULT',
                data: {
                    orderId: orderId,
                    token: txnToken,
                    tokenType: 'TXN_TOKEN',
                    amount: amount,
                },
                merchant: {
                    redirect: false,
                },
                handler: {
                    transactionStatus: (response) => {
                        if (response.STATUS === 'TXN_SUCCESS') {
                            this.confirmOrder(orderId, 'paytm', response);
                        } else if (response.STATUS === 'TXN_FAILURE') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }

                        window.Paytm.CheckoutJS.close();
                    },
                    notifyMerchant: (eventName) => {
                        if (eventName === 'APP_CLOSED') {
                            this.placingOrder = false;

                            this.deleteOrder(orderId);
                        }
                    },
                },
            };

            window.Paytm.CheckoutJS.init(config).then(() => {
                window.Paytm.CheckoutJS.invoke();
            }).catch(() => {
                this.deleteOrder(orderId);
            });
        },

        confirmRazorpayPayment(razorpayOrder) {
            this.placingOrder = false;

            let vm = this;

            new window.Razorpay({
                key: EcomShop.razorpayKeyId,
                name: EcomShop.storeName,
                description: `Payment for order #${razorpayOrder.receipt}`,
                image: EcomShop.storeLogo,
                order_id: razorpayOrder.id,
                handler(response) {
                    vm.placingOrder = true;

                    vm.confirmOrder(razorpayOrder.receipt, 'razorpay', response);
                },
                modal: {
                    ondismiss() {
                        vm.deleteOrder(razorpayOrder.receipt.receipt);
                    },
                },
                prefill: {
                    name: `${vm.form.billing.first_name} ${vm.form.billing.last_name}`,
                    email: vm.form.customer_email,
                    contact: vm.form.customer_phone,
                },
            }).open();
        },
    },
    directives: {
        phone: {
            bind(el) {
                function replaceNumberForInput(value) {
                    let val = '';
                    //const x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,4})/);
                    const x = value.replace(/\D/g, '').match(/(\d{0,1})(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
                    x[1] = '+7';
                    val = !x[3] ? x[1] + ' (' + x[2] : x[1] + ' (' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '') + (x[5] ? '-' + x[5] : '');
                    return val;
                    // if (! x[2] && x[1] !== '') {
                    //    val = x[1] === '8' ? x[1] : '8' + x[1];
                    //} else {
                    //  val = ! x[3] ? x[1] + x[2] : x[1] + '(' + x[2] + ') ' + x[3] + (x[4] ? '-' + x[4] : '');
                    // }

                    //return val;
                }

                function replaceNumberForPaste(value) {
                    const r = value.replace(/\D/g, '');
                    let val = r;
                    if (val.charAt(0) === '7') {
                        val = '8' + val.slice(1);
                    }
                    return replaceNumberForInput(val);
                }

                el.oninput = function (e) {
                    if (! e.isTrusted) {
                        return;
                    }
                    this.value = replaceNumberForInput(this.value);
                };

                el.onpaste = function () {
                    setTimeout(() => {
                        const pasteVal = el.value;
                        this.value = replaceNumberForPaste(pasteVal);
                    });
                };

            },
        },
        'input-mask': {
            params: ['mask'],

            bind(el) {
                //var im = new Inputmask(this.params.mask);
                //im.mask(el);
                //$(this.el).inputmask({
                //  mask: this.params.mask,
                //});
            },
        },
    },
};
